import { fetchWrapper } from '../../utils/request';
import { endpoint } from './endpoint';
import { ILinePut, ILineNamePut } from '../../Types';

export async function autoCreateLines(
  templateLine: string,
  numLinesToCreate?: number,
  durationInMonths?: number,
) {
  return fetchWrapper(endpoint + `/v1/lines/auto-create`, {
    method: 'post',
    body: JSON.stringify({
      templateLine,
      suggestedAmount: numLinesToCreate,
      durationInMonths: durationInMonths,
    }),
  }).then((res) => res.json());
}

export async function editLineV2(line: ILinePut) {
  const lineId = line.id;
  delete line.id;
  return fetchWrapper(endpoint + `/v1/lines/v2/${lineId}`, {
    method: 'put',
    body: JSON.stringify(line),
  }).then((res) => res.json());
}

export async function editLineNameV2(line: ILineNamePut) {
  const lineId = line.id;

  return fetchWrapper(endpoint + `/v1/lines/name/${lineId}`, {
    method: 'put',
    body: JSON.stringify(line),
  });
}
